import { useDebounce } from 'use-debounce';

function useDebounceCustom(value, time) {
  const [valueDebounce] = useDebounce(value, time);
  return [valueDebounce];
}

export default useDebounceCustom;
